import { atom } from 'recoil';

export const accordionItemAtom = atom<string | null>({
  key: 'DataPanelAccordion/items',
  default: null
});
